const _sagecell = window.sagecell || {};
window.sagecell = _sagecell;

export default _sagecell;
